<template>
    <div class="feedback-step">
        <b-field>
            <b-input type="textarea"
                     class="feedback-textarea"
                     v-model="feedbackText"
                     :placeholder="placeholder"></b-input>
        </b-field>
    </div>
</template>

<script>
    export default {
        name: "StepAddFeedback",
        props: {
            feedback: {
            }
        },
        data() {
            return {
                feedbackText: '',
                //placeholder: this.$i18n.messages[this.$store.state.lang.locale].comments_placeholder
                placeholder: 'Comments'
            }
        },
        mounted() {
            this.feedbackText = this.feedback;
        },
        computed: {
            stepResult() {
                return {
                    feedbackText: this.feedbackText
                }
            }
        }
    }
</script>

<style scoped>

</style>
